// Shared type definitions for VisxChart components

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type YScale = any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type XScale = any;

export interface DataPoint {
  timestamp: number;
  price: number;
}

export interface Margin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

// Default margin values used throughout the chart
export const DEFAULT_MARGIN: Margin = {
  top: 20,
  right: 0,
  bottom: 20,
  left: 0,
};
